
export const getMatches = (matchDay, matchesState) => {
    if (!matchDay?.gameDayMatches) return [];
    if (!matchesState?.length) return [];
    return matchDay?.gameDayMatches?.reduce((acc, id) => {
        const match = matchesState?.find(cur => cur?.id === id);
        if(match) {
            return [...acc, match];
        } else {
            return acc;
        }
    }, [])
};